import { z } from 'zod';

export const productBrandIndicationCoreSchema = z.object({
  productBrandId: z.uuid(),
  indicationId: z.uuid(),
  isDefault: z.boolean(),
});
export type ProductBrandIndicationCore = z.infer<typeof productBrandIndicationCoreSchema>;

export const productBrandIndicationNamedSchema = productBrandIndicationCoreSchema.extend({
  productBrandName: z.string(),
  indicationName: z.string(),
});
export type ProductBrandIndicationNamed = z.infer<typeof productBrandIndicationNamedSchema>;

export const productBrandIndicationNamedWithIdSchema = productBrandIndicationNamedSchema.extend({
  id: z.uuid(),
});
